import { useSettings } from '@capsicum/common';
import { useCallback } from 'react';

import { useWCPledgeBonusPercentage } from './useWCPledgeBonusPercentage';

type HowItWorksFaq = {
	content: JSX.Element;
	id: string;
	title: JSX.Element;
};

export const useWCPledgeHowItWorksTab = () => {
	const { formattedBonusPercentage } = useWCPledgeBonusPercentage();
	const {
		settings: { chilizChainDocumentationLink, wcPledgeFaqsKeys }
	} = useSettings();

	const getFaqsWithParsed = useCallback(
		(items: Array<{ component: HowItWorksFaq; key: string }>) => {
			return wcPledgeFaqsKeys
				.map(questionKey => {
					const customItem = items.find(item => item.key === questionKey);

					return customItem ? customItem.component : questionKey;
				})
				.filter(Boolean);
		},
		[wcPledgeFaqsKeys]
	);

	return {
		chilizChainDocumentationLink,
		formattedBonusPercentage,
		getFaqsWithParsed
	};
};
